// @author 云龙
// 引用方法 import tableSticky from '@/utils/tableSticky';
// 使用方法 Vue.directive('tableSticky', tableSticky);
// 基础使用 <el-table v-tableSticky>  <el-table v-tableSticky="10">
// 有固定列 <el-table v-tableSticky.fixed> <el-table v-tableSticky.fixed="10">
// 注意:el-table 组件 外层使用普通div包裹,不要使用el-main等

let headerEl = null;
let observer = null;
// 用于存储上一次的固定列
let previousFixedColumns = new Set();
let previousRightFixedColumns = new Set();

// 移除固定列样式
const removeFixedStyles = function removeFixedStyles(el, columnIds) {
  const tHeader = el.querySelector('.el-table__header-wrapper');
  columnIds.forEach((id) => {
    const cell = tHeader.querySelector('th.' + id);
    if (cell) {
      cell.style.position = 'relative';
      cell.style.left = '';
      cell.style.right = '';
      cell.style.top = '';
      cell.style.zIndex = '';
    }
  });
};

// 头部吸顶
const stickyThead = function stickyThead(el, binging, vnode) {
  let top = '0px';
  if (!isNaN(Number(binging.value))) {
    top = binging.value + 'px';
  }
  if (
    typeof binging.value === 'string' &&
    document.querySelector(binging.value)
  ) {
    let rect = document.querySelector(binging.value).getBoundingClientRect();
    top = rect ? rect.top + rect.height + 'px' : '0px';
  }

  el.style.overflow = 'visible';
  let tHeader = el.querySelector('.el-table__header-wrapper');
  tHeader.style.position = 'sticky';
  tHeader.style.top = top;
  tHeader.style.zIndex = 20;

  let ths = tHeader.querySelectorAll('th.is-hidden');
  ths.forEach(function (item) {
    item.classList.remove('is-hidden');
  });

  let table = vnode.context.$children.find(function (item) {
    return item.$el === el;
  });

  if (!table) return;

  table.doLayout();

  // 获取当前固定列
  const currentFixedColumns = new Set(table.fixedColumns.map((col) => col.id));
  const currentRightFixedColumns = new Set(
    table.rightFixedColumns.map((col) => col.id)
  );

  // 找出不再固定的列
  const removedFixedColumns = [...previousFixedColumns].filter(
    (id) => !currentFixedColumns.has(id)
  );
  const removedRightFixedColumns = [...previousRightFixedColumns].filter(
    (id) => !currentRightFixedColumns.has(id)
  );

  // 移除不再固定的列的样式
  if (removedFixedColumns.length > 0) {
    removeFixedStyles(el, removedFixedColumns);
  }
  if (removedRightFixedColumns.length > 0) {
    removeFixedStyles(el, removedRightFixedColumns);
  }

  // 更新固定列记录
  previousFixedColumns = currentFixedColumns;
  previousRightFixedColumns = currentRightFixedColumns;

  // 左固定列
  let leftFixed = table.fixedColumns;
  if (leftFixed && leftFixed.length) {
    let leftFixedWidth = 0;
    leftFixed.forEach(function (item) {
      let cell = tHeader.querySelector('th.' + item.id);
      if (cell) {
        let itemW = cell.getBoundingClientRect().width;
        cell.style.position = 'sticky';
        cell.style.left = leftFixedWidth + 'px';
        cell.style.top = top;
        cell.style.zIndex = 30;
        leftFixedWidth += itemW;
      }
    });
  }

  // 右固定列
  let rightFixed = table.rightFixedColumns;
  if (rightFixed && rightFixed.length) {
    let rightFixedWidth = 0;
    for (let i = rightFixed.length - 1; i >= 0; i--) {
      let cell = tHeader.querySelector('th.' + rightFixed[i].id);
      if (cell) {
        let itemW = cell.getBoundingClientRect().width;
        cell.style.position = 'sticky';
        cell.style.right = rightFixedWidth + 'px';
        cell.style.top = top;
        cell.style.zIndex = 30;
        rightFixedWidth += itemW;
      }
    }
  }
};

// 简易吸顶
const sticky = function sticky(el, binging) {
  let top = '0px';
  if (!isNaN(Number(binging.value))) {
    top = binging.value + 'px';
  }
  if (
    typeof binging.value === 'string' &&
    document.querySelector(binging.value)
  ) {
    let rect = document.querySelector(binging.value).getBoundingClientRect();
    top = rect ? rect.top + rect.height + 'px' : '0px';
  }

  el.style.overflow = 'visible';
  let tHeader = el.querySelector('.el-table__header-wrapper');
  tHeader.style.position = 'sticky';
  tHeader.style.top = top;
  tHeader.style.zIndex = 20;
};

export default {
  bind: function inserted(el, binging, vnode) {
    headerEl = el.querySelector('.el-table__header-wrapper table thead');
    observer = new ResizeObserver(() => {
      stickyThead(el, binging, vnode);
    });
    if (headerEl) {
      observer?.observe(headerEl);
    }
    if (binging.modifiers.fixed) {
      setTimeout(() => stickyThead(el, binging, vnode), 0);
    } else {
      sticky(el, binging, vnode);
    }
  },
  update: (el, binging, vnode) => {
    if (binging.modifiers.fixed) {
      setTimeout(() => stickyThead(el, binging, vnode), 0);
    } else {
      // 当解除固定时，移除所有固定样式
      removeFixedStyles(el, []);
    }
  }
  /**
   * 解除绑定会滞后,进入下一个组件后会在bind之后执行，导致bind中监听失效
   * 实测注释掉unbind后，进入下一个组件后，bind中监听会生效，并且不会触发多次
   */
  // unbind: function unbind() {
  //   console.log(' 解绑 headerEl=====>', headerEl);
  //   if (headerEl) {
  //     observer.unobserve(headerEl);
  //     observer.disconnect();
  //     headerEl = null;
  //     observer = null;
  //   }
  // }
};
